import Spinner from "../Spinner";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useDelayedVisibility } from "../../hooks/useDelayedVisibility";

export default function RecordingModeGate({
  allowed,
  children,
  loading = false,
  redirectTo = "/home",
}) {
  const { t } = useTranslation();
  const showLoadingMessage = useDelayedVisibility(loading);

  // Distinguish "still resolving backend-driven access" from a real deny so
  // direct recording-route visits do not bounce users away during startup.
  if (loading) {
    return (
      <div
        className="w-full min-h-52 flex flex-col items-center justify-center gap-3"
        role="status"
        aria-live="polite"
      >
        <Spinner />
        {showLoadingMessage ? (
          <p>{t("regionalBackend.loading.recordingAccess")}</p>
        ) : null}
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}
